import React, {useState, useEffect} from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Footer from '../../components/Footer'
import Navbar from "../../components/Navbar"
import PreNav from "../../components/PreNav"
import { getProductDetails } from '../../redux/actions/productActions'
import {useDispatch, useSelector} from "react-redux"
import Loading from '../util/Loading'
import { addToCart } from '../../redux/actions/cartAction'
import NotFound from '../util/NotFound'

const IndividualProduct = () => {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [product, setProduct] = useState([])
  const {handle} = useParams()
  const [selectedProduct, setSelectedProduct] = useState({})
  const [loading, setLoading] = useState(true)

  // image
  const [images, setImages] = useState([])
  const [selectedImage, setSelectedImage] = useState(images[0])

  // option
  const [option1array, setOption1Array] = useState([])
  const [option2array, setOption2Array] = useState([])
  const [selectedOption1, setSelectedOption1] = useState("")
  const [selectedOption2, setSelectedOption2] = useState("")

  useEffect(() => {
    dispatch(getProductDetails(handle))
    .then(res=>{
      if (!res.success) {
        navigate('/notfound')
      } else {
        setProduct(res.product)
        setLoading(false)
      }
    })
  }, [])

  useEffect(() => {
    if (!loading) {
      productSettings()
      setSelectedProduct(product[0])
    }
  }, [loading])
  

  const productSettings = () => {
    product.map((item, index)=>{
      setImageArray(item.variant_image)
      SetOption1ArrayInitially(item.option1_value)
      SetOption2ArrayInitially(item.option2_value)
    })
    setSelectedImage(images[0])
    setSelectedOption1(option1array[0])
    setSelectedOption2(option2array[0])
  }

  const setImageArray = (imageUrl) => {
    let imageExists = images.includes(imageUrl)
    if (!imageExists) {
      images.push(imageUrl)
    }
  }

    const SetOption1ArrayInitially = (option1_value) => {
    let valueExists = option1array.includes(option1_value)
    if (!valueExists) {
      option1array.push(option1_value)
    }
  }

  const SetOption2ArrayInitially = (option2_value) => {
    let valueExists = option2array.includes(option2_value)
    if (!valueExists) {
      option2array.push(option2_value)
    }
  }

  useEffect(() => {
  
    let selectedProductInArray = product.find(item => item.option1_value === selectedOption1 && item.option2_value === selectedOption2)
    if (selectedProductInArray) {
      setSelectedProduct(selectedProductInArray)
      setSelectedImage(selectedProduct.variant_image)
    } else {
      setSelectedImage(images[0])
      setSelectedProduct(product[0])
    }
  
  }, [selectedOption1, selectedOption2, selectedProduct])

  const selectedProductSettings = () => {
    let selectedProductInArray = product.find(item => item.option1_value === selectedOption1 && item.option2_value === selectedOption2)
    if (selectedProductInArray) {
      setSelectedProduct(selectedProductInArray)
      setSelectedImage(selectedProduct.variant_image)
    } else {
      setSelectedImage(images[0])
      setSelectedProduct(product[0])
    }
  }
  
  const addToCartHandler = () => {
    const data = {
      ...selectedProduct,
      title: product[0].title,
      option1_name: product[0].option1_name,
      option2_name: product[0].option2_name,
    }
    dispatch(addToCart(data, 1))
  }

  const handleBuyNow = () => {
    const data = {
      ...selectedProduct,
      title: product[0].title,
      option1_name: product[0].option1_name,
      option2_name: product[0].option2_name,
      quantity: 1
    }
    localStorage.setItem("checkoutItems", JSON.stringify([data]))
    document.getElementById("checkoutAnchorTag").click()
  }
  

  return (
    loading ? <Loading/> : <>
        <PreNav/>
        <Navbar/>
        <section>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="row mb-8 mb-md-0">
                    <div className="col-2">
                      <div className="d-flex flex-column">
                        {images.map((item, index)=>(
                          <div className={`mt-3 ${selectedImage === item ? 'border border-dark' : ''}`} onClick={()=>setSelectedImage(item)} key={index} style={{height:"75px", width:"100%", backgroundImage:`url(${item})`, backgroundPosition:"center", backgroundRepeat:"no-repeat", backgroundSize:"contain", cursor:"pointer"}}></div>
                        ))}
                      </div>
                    </div>
                    <div className="col-10">
                      {/* <div className="border" style={{backgroundImage:`url(${selectedImage})`, backgroundPosition:"center", backgroundRepeat:"no-repeat", backgroundSize:"contain"}}></div> */}
                      <img src={selectedImage} className="w-100" style={{height:"auto"}} alt="" />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 pl-lg-10">
                  {/* Header */}
                  <div className="row mb-1">
                    <div className="col">
                      {/* Preheading */}
                      <a className="text-muted" href="/collections/framed-art">Framed Art</a>
                    </div>
                  </div>
                  {/* Heading */}
                  <h3 className="mb-2">{product[0].title}</h3>
                  {/* Price */}
                  <div className="mb-7 text-gray">
                    <span className="ml-1 font-size-h6 font-weight-normal">
                      <span className='text-danger '><s>Rs. {selectedProduct &&  selectedProduct.variant_compare_at_price}</s></span> 
                      <span className=''> Rs. {selectedProduct && selectedProduct.variant_price}</span> 
                      <span className='text-success'> Save Rs. {selectedProduct && selectedProduct.variant_compare_at_price-selectedProduct.variant_price}</span>
                    <br />
                    <span className='font-size-sm'>Tax Included</span>
                    </span>
                  </div>
                  {/* Form */}
                    <div className="form-group">
                      {/* Label */}
                      <p className="mb-2">{product[0].option1_name}</p>
                      {/* Radio */}
                      <div className="mb-2 d-flex flex-wrap" style={{columnGap: "9px"}}>
                      {option1array.map((item, index)=>(
                          <p className={`mb-3 p-3 px-5 border cursor-pointer text-capitalize ${selectedOption1===item ? "border-dark text-dark" : "text-muted"}`} onClick={()=>setSelectedOption1(item)}>{item}</p>
                        ))}
                      </div>
                      <div className="form-group">
                          {/* Label */}
                      <p className="mb-2">{product[0].option2_name}</p>
                      {/* radio */}
                      <div className="mb-2 d-flex flex-wrap" style={{columnGap: "9px"}}>
                      {option2array.map((item, index)=>(
                          <p className={`mb-3 p-3 px-5 border cursor-pointer text-capitalize ${selectedOption2===item ? "border-dark text-dark" : "text-muted"}`} onClick={()=>setSelectedOption2(item)}>{item}</p>
                        ))}
                      </div>
                      </div>
                      
                      {/* Size chart */}
                      <p className="mb-6">
                        {/* <img src="https://yevgenysim-turkey.github.io/shopper/assets/img/icons/icon-ruler.svg" alt="..." className="img-fluid" /> <a className="text-reset text-decoration-underline ml-3" data-toggle="modal" href="#modalSizeChart">Size chart</a> */}
                        <a className='text-dark' href="#sizeChartModal">
                          <i className="bi bi-rulers mr-2"></i>
                          <span>Size Chart</span>
                        </a>
                      </p>
                      <div className="form-row mb-7">
                        <div className="col-12">
                          {/* Submit */}
                          <button className="btn btn-block btn-dark mb-2" onClick={addToCartHandler}>
                            <i className="bi bi-cart mr-2" /> Add to Cart
                          </button>
                        </div>
                        <div className="col-12">
                          {/* Wishlist */}
                          <button className="btn btn-outline-dark btn-block mb-2" onClick={handleBuyNow}>
                            Buy Now <i className="bi bi-heart ml-2" />
                          </button>
                        </div>
                      </div>
                      <div className='pb-5' dangerouslySetInnerHTML={{__html: product[0].body__html_}} />
                      {/* Share */}
                      <p className="mb-0">
                        <span className="mr-4">Share:</span>
                        <a className="btn btn-xxs mr-2 btn-circle btn-light font-size-xxxs text-gray-350" href="#!">
                          <i className="bi bi-twitter" />
                        </a>
                        <a className="btn btn-xxs mr-2 btn-circle btn-light font-size-xxxs text-gray-350" href="#!">
                          <i className="bi bi-facebook" />
                        </a>
                        <a className="btn btn-xxs mr-2 btn-circle btn-light font-size-xxxs text-gray-350" href="#!">
                          <i className="bi bi-pinterest" />
                        </a>
                      </p>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <a href="/checkout" id='checkoutAnchorTag' className="d-none"></a>
        <Footer/>
    </>
  )
}

export default IndividualProduct